export default {"src":"/_next/static/media/ic-play-new.5c7c7e99.svg","height":103,"width":103};